<ng-container *ngIf="(showMaintenanceMode$ | async) !== true as showContent; else showMaintenanceMode">
  <ng-content select="ssc-header"></ng-content>

  <main [class]="containerSize">
    <section>
      <ng-content></ng-content>
    </section>
  </main>

  <ssc-footer [showContactButton]="showFooterContactButton"></ssc-footer>
  <ssc-error-popup></ssc-error-popup>
</ng-container>
<ng-template #showMaintenanceMode>
  <div class="maintenance-mode-background">
    <visana-lib-overlay-backdrop></visana-lib-overlay-backdrop>
    <visana-lib-info-box
      [iconName]="'warning'"
      [description]="'ERROR.MAINTENANCE.TEXT' | translate"
      [infoType]="'warn'"
      [svgAriaLabel]="'Warnung'"
    ></visana-lib-info-box>
  </div>
</ng-template>
